import React, { useEffect, useRef, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { NavLink } from "react-router-dom";
import { FaCartPlus } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";
import { toast } from "react-toastify";
import axios from "axios";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import { IoIosPricetags } from "react-icons/io";
import inventory from "../../Asset/inventory.png";
import Counter from "./Counter";
import Customer from "./customer";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrder,
  RESETORDER,
  selectOrder,
  selectOrderSuccess,
} from "../../redux/features/order/OrderSlice";
import Print from "./print";
import Return from "./Return";
import useRedirectLogoutUser from "../../CustomHook/useRedirectLogoutUser";

const Order = () => {
  useRedirectLogoutUser("/login");
  const [order, setOrder] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [discount, setDiscount] = useState();
  const [amountPaid, setAmountPaid] = useState("");
  const [change, setChange] = useState("");
  const [nameOrProductID, setNameOrProductID] = useState("");
  const [paymentType, setPaymentType] = useState("cash");
  const [customer, setCustomer] = useState({
    customerName: "",
    customerNumber: "",
  });
  const [orderData, setOrderData] = useState({
    id: 0,
    name: "",
    quantity: 0,
    tax: 0,
    cost: 0,
    rate: 0,
  });
  const [filterItems, setFilterItems] = useState([]);

  const addToOrder = (newOrderData) => {
    setOrder((prevOrders) => {
      const existingOrder = prevOrders.find(
        (item) => item.id === newOrderData.id
      );

      if (existingOrder) {
        return prevOrders.map((item) =>
          item.id === newOrderData.id
            ? { ...item, quantity: item.quantity + newOrderData.quantity }
            : item
        );
      } else {
        return [...prevOrders, newOrderData];
      }
    });
  };

  const getItemByBarcode = async (barcode) => {
    if (!barcode) {
      toast.error("Barcode is required");
      return;
    }

    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/items/getItemByBarcode/${barcode}`
      );
      const fetchedData = response.data.data;
      if (fetchedData) {
        setOrderData((prev) => ({
          ...prev,
          id: fetchedData.productId || prev.id,
          name: fetchedData.name || prev.name,
          rate: fetchedData.price || prev.rate,
          cost: fetchedData.cost || prev.cost,
          tax: fetchedData.tax === 0 ? 0 : fetchedData.tax || prev.tax,
          quantity: 1,
        }));
        setBarcode("");
      } else {
        toast.error("Invalid data received from the server.");
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  const getItemByNameOrProductID = async (nameOrProductID) => {
    if (!nameOrProductID) {
      toast.error("nameOrProductID is required");
      return;
    }
    try {
      const response = await axios.get(
        `${BACKEND_BASEURL}api/items/getItemByNameOrProductID/${nameOrProductID}`
      );
      const fetchedData = response.data.data;
      setFilterItems(fetchedData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An unexpected error occurred";
      console.log(message);
    }
  };

  useEffect(() => {
    if (barcode) {
      getItemByBarcode(barcode);
      setBarcode("");
    }
  }, [barcode]);

  useEffect(() => {
    if (nameOrProductID) {
      getItemByNameOrProductID(nameOrProductID);
    }
  }, [nameOrProductID]);

  useEffect(() => {
    if (orderData.id && orderData.name) {
      addToOrder(orderData);
    }
  }, [orderData]);

  const handleSetOrder = (item) => {
    if (item.inventory > 0) {
      const newOrderData = {
        id: item.productId,
        name: item.name,
        rate: item.price,
        cost: item.cost,
        tax: item.tax === 0 ? 0 : item.tax,
        quantity: 1,
      };
      addToOrder(newOrderData);
      setNameOrProductID("");
    } else {
      toast.error("Item is out of stock");
    }
  };

  const TotalOrderAmount = order.reduce(
    (total, item) => total + item.quantity * item.rate,
    0
  );

  const handleQuantityChange = (id, newQuantity) => {
    const updatedOrderItems = order.map((item) =>
      item.id === id ? { ...item, quantity: newQuantity } : item
    );
    setOrder(updatedOrderItems);
  };

  const handleDelete = (id) => {
    const updatedOrderItems = order.filter((item) => item.id !== id);
    setOrder(updatedOrderItems);
  };

  const [errors, setErrors] = useState({});

  const validation = () => {
    const newErrors = {};
    if (!order || order.length === 0) {
      newErrors.order = "At least 1 item is required to place an order.";
      toast.error(errors.order);
    }
    if (
      !amountPaid ||
      amountPaid <
        (discount ? TotalOrderAmount - Number(discount) : TotalOrderAmount)
    ) {
      newErrors.amountPaid =
        "Paid Amount must be greater than or equal to the total amount.";
      toast.error(errors.amountPaid);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();
  const isSuccess = useSelector(selectOrderSuccess);
  const currentOrder = useSelector(selectOrder);

  const handleOrder = async () => {
    if (validation()) {
      const orderDetail = {
        customer: customer.customerNumber ? customer : null,
        products: order,
        totalAmount: TotalOrderAmount,
        amountType: paymentType,
        totalAmountDiscount: Number(discount),
        totalAmountAfterDiscount: discount
          ? TotalOrderAmount - Number(discount)
          : TotalOrderAmount,
        paidAmount: amountPaid,
        returnAmount: Number(change),
      };
      await dispatch(createOrder(orderDetail));

      console.log(orderDetail);
    }
  };

  const handleKeyDown = (event) => {
    // if (event.key === "Enter") {
    //   handleOrder();
    // }
    // if (event.key === "b") {
    //   inputRef.current?.focus();
    // }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const openNewWindow = () => {
    window.open(window.location.href, "_blank", "noopener,noreferrer");
  };
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleAmount = (e) => {
    const enteredAmount = Number(e.target.value);
    setAmountPaid(enteredAmount);

    const effectiveTotal = discount
      ? TotalOrderAmount - Number(discount)
      : TotalOrderAmount;

    const calculatedChange =
      enteredAmount > effectiveTotal ? enteredAmount - effectiveTotal : 0;

    setChange(calculatedChange);
  };

  const printRef = useRef();

   const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;

  const handlePrint = () => {
    const isMobile =
      /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
    if (isMobile) {
      return;
    }
    const printContent = printRef.current;
    if (!printContent) return;
    toast.dismiss();

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}  
                    ${printStyles}

          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.85rem]{
            font-size: 13.50px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
            }
            .text-[.73rem]{
            font-size: 11.68px;
           
            }
            .text-[.6rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };


  const dispatchReset = useDispatch();

  useEffect(() => {
    if (isSuccess) {
      handlePrint();
      setDiscount();
      setChange();
      setAmountPaid();
      setOrder([]);
      dispatchReset(RESETORDER());
    }
  }, [isSuccess, dispatchReset]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1] relative overflow-hidden ">
      {/* Navbar */}
      <Navbar page="Order" />

      <div className="flex justify-center w-full items-center gap-3 mt-2 relative ">
        <input
          ref={inputRef}
          type="text"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          className=" outline-none lg:p-3 p-1.5   lg:w-[30%] w-[40%] bg-transparent text-[#A9A9A9] border border-[#0D868C] rounded-xl"
          placeholder="Barcode"
        />
        <div className=" lg:w-[30%] w-[40%] relative">
          <input
            type="text"
            value={nameOrProductID}
            onChange={(e) => setNameOrProductID(e.target.value)}
            className=" outline-none lg:p-3 p-1.5 w-full  bg-transparent text-[#A9A9A9] border border-[#0D868C] rounded-xl"
            placeholder="Product name & id"
          />

          {nameOrProductID && filterItems?.length > 0 && (
            <div className=" absolute bg-white w-full mt-1 rounded-lg flex flex-col text-[#0D868C] shadow max-h-[15rem] h-min overflow-y-auto  z-20 scrollbar-hide">
              {filterItems.map((item) => (
                <div
                  key={item._id}
                  className="flex flex-col p-2 border-b last:border-none hover:bg-[#A9A9A9]/10 cursor-pointer"
                  onClick={() => handleSetOrder(item)}
                >
                  <div className="flex gap-2 text-[12px]  justify-between items-center">
                    <div className="flex items-center gap-2">
                      <p className="font-medium">{item.productId}</p>
                      <p className=" capitalize font-bold">{item.name}</p>
                    </div>
                    <p className="text-wrap text-[12px] flex items-center gap-1">
                      <IoIosPricetags />
                      {item.price}
                    </p>
                  </div>
                  <p className="flex text-[12px] gap-2 items-center">
                    <img src={inventory} className="w-4" alt="" />{" "}
                    {item.inventory}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
        <Customer customer={customer} setCustomer={setCustomer} />
      </div>

      <div className="flex overflow-hidden items-start justify-between w-full h-full">
        <div className="mt-[2rem] w-[68%] overflow-auto scrollbar-hide touch-auto border-none bg-white h-full pb-12 rounded-r-lg ">
          <table className="w-[100%]   ">
            <thead className="bg-[#D9D9D9] lg:text-[1rem] text-[.9rem] capitalize sticky top-0 ">
              <tr>
                <th
                  className="p-3 font-bold tracking-wide text-start w-[50%]"
                  scope="col"
                >
                  name
                </th>
                <th
                  className="p-3 font-bold tracking-wide text-center w-[15%]"
                  scope="col"
                >
                  quantity
                </th>
                <th
                  className="p-3 font-bold tracking-wide text-center w-[10%]"
                  scope="col"
                >
                  tax
                </th>
                <th
                  className="p-3 font-bold tracking-wide text-center  w-[10%]"
                  scope="col"
                >
                  rate
                </th>
                <th
                  className="p-3 font-bold tracking-wide text-center  w-[10%]"
                  scope="col"
                >
                  amount
                </th>
                <th
                  className="p-3 font-bold tracking-wide text-center  w-[5%]"
                  scope="col"
                >
                  del
                </th>
              </tr>
            </thead>
            <tbody className="  overflow-y-auto ">
              {order?.map((item) => (
                <tr key={item.id} className="border-b last:border-none mx-2">
                  <td
                    className={`p-3  lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-start   `}
                  >
                    {item.name}
                  </td>

                  <td
                    className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                  >
                    <Counter
                      quantity={item.quantity}
                      onQuantityChange={(newQuantity) =>
                        handleQuantityChange(item.id, newQuantity)
                      }
                    />
                    {/* {item.quantity} */}
                  </td>
                  <td
                    className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                  >
                    {item.tax}%
                  </td>
                  <td
                    className={`p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center   `}
                  >
                    {item.rate}
                  </td>

                  <td className="p-3 lg:text-sm text-[12px] text-gray-700 whitespace-nowrap text-center">
                    {item.rate * item.quantity}
                  </td>
                  <td className="p-3 lg:text-xl text-[14px] text-gray-700 whitespace-nowrap text-center">
                    <CiCircleRemove
                      className=" cursor-pointer"
                      onClick={() => handleDelete(item.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-[28%] mt-[2rem]">
          <div className="w-full flex flex-col lg:gap-3 gap-2">
            <div className="flex flex-col">
              <label
                htmlFor=""
                className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
              >
                {" "}
                Discount
              </label>
              <input
                type="number"
                value={discount}
                min={0}
                onChange={(e) => setDiscount(e.target.value)}
                className="w-[84%] lg:pt-3 pt-1.5 lg:text-[.88rem] text-[.75rem] rounded-none  bg-transparent border-b border-[#0D868C] text-[#a9a9a9] outline-none "
                placeholder="Discount"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor=""
                className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
              >
                Paid Amount
              </label>
              <input
                type="number"
                min={0}
                value={amountPaid}
                onChange={handleAmount}
                className="w-[84%] lg:pt-3 pt-1.5 lg:text-[.88rem] text-[.75rem] rounded-none  bg-transparent border-b border-[#0D868C] text-[#a9a9a9] outline-none "
                placeholder="Paid Amount"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor=""
                className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
              >
                Total
              </label>
              <input
                type="text"
                value={
                  discount
                    ? TotalOrderAmount - Number(discount)
                    : TotalOrderAmount
                }
                className="w-[84%] lg:pt-3 pt-1.5 lg:text-[.88rem] text-[.75rem] rounded-none bg-transparent border-b border-[#0D868C] text-[#a9a9a9] outline-none "
                placeholder="Amount Due"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor=""
                className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
              >
                Change Due
              </label>
              <input
                type="text"
                value={change}
                className="w-[84%] lg:pt-3 pt-1.5 lg:text-[.88rem] text-[.75rem] rounded-none bg-transparent border-b border-[#0D868C] text-[#a9a9a9] outline-none "
                placeholder="Change Due"
              />
            </div>
            <div className="flex flex-col">
              <label
                htmlFor=""
                className="lg:text-[.75rem] text-[.65rem] font-semibold text-[#7D7D7D] leading-none"
              >
                Amount Type
              </label>
              <select
                className="w-[84%] lg:pt-3 pt-1.5 lg:text-[.88rem] text-[.75rem]  bg-transparent border-b border-[#0D868C] text-[#a9a9a9] outline-none"
                value={paymentType}
                onChange={(e) => setPaymentType(e.target.value)}
              >
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="online">Online</option>
              </select>
            </div>
            <button
              onClick={handleOrder}
              className="w-[84%] lg:p-3 p-1.5  lg:text-[1rem] text-[.9rem] rounded-xl bg-[#0D868C] text-white font-semibold outline-none"
            >
              Pay
            </button>
            <Return />
          </div>
          <div></div>
        </div>
      </div>
      <div className=" absolute  bottom-3 lg:right-5 right-3 leading-none bg-[#0D868C] text-white py-3 px-5 rounded-full">
        <NavLink
          to={"#"}
          className="flex justify-center items-center gap-2"
          onClick={openNewWindow}
        >
          <FaCartPlus />
          New Order
        </NavLink>
      </div>
      <Print currentOrder={currentOrder} printRef={printRef} />
    </div>
  );
};

export default Order;
